<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    @if (formField.label) {
        <label for="form-element-{{ formField.id }}" (click)="selectElement?.focus()" class="form-element-label">
            {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
        </label>
    }
    <ng-select
        id="form-element-{{ formField.id }}"
        class="select-control"
        name="formField{{ formField.id }}"
        appSelectAccessibility
        [inputAriaLabelAttribute]="formField.label || formField.placeholder"
        bindLabel="value"
        bindValue="value"
        dropdownPosition="bottom"
        #select
        [searchable]="false"
        [clearable]="false"
        [required]="formField.isRequired"
        [placeholder]="formField.placeholder"
        [(ngModel)]="formField.value">
        @for (status of formField.possibleValues; track status) {
            <ng-option [value]="+status.value">
                {{ +status.value | ticketStatus }}
            </ng-option>
        }
    </ng-select>

    @if (formService.isSubmitted && !formField.value && formField.isRequired) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
